import { actions } from './';

const initialState = () => {
    return {
        items: [],
        isBusy: false,
        error: null
    };
};

export default function(state = initialState(), action) {
    switch (action.type) {
        case actions.INVITES_CLEAR: {
          return { ...state, items: [] }
        }

        case actions.INVITES_FETCH: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.INVITES_FETCH_SUCCESS: {
            const items = action.value;
            return {
                ...state,
                isBusy: false,
                error: null,
                items
            };
        }

        case actions.INVITES_FETCH_FAILURE: {
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        }

        case actions.INVITES_CREATE: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.INVITES_CREATE_SUCCESS: {
            const items = action.value;
            return {
                ...state,
                isBusy: false,
                error: null,
                items
            };
        }

        case actions.INVITES_CREATE_FAILURE: {
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        }

        case actions.INVITES_REMOVE: {
            return {
                ...state,
                isBusy: true,
                error: null
            };
        }

        case actions.INVITES_REMOVE_SUCCESS: {
            const items = state.items.filter((item) => item.inviteToken !== action.value.inviteToken);
            return {
                ...state,
                isBusy: false,
                error: null,
                items
            };
        }

        case actions.INVITES_REMOVE_FAILURE: {
            return {
                ...state,
                isBusy: false,
                error: action.value
            };
        }

        default:
            return state;
    }
}
